// converts "lowercase SENTENCE" into "Lowercase Sentence"
export const capitalizeWords = (str: string, lowercase: boolean = true): string => {
  if (typeof str !== 'string') return str;
  if (lowercase) return str.toLowerCase().replace(/(^| )(\w)/g, (s) => s.toUpperCase());
  return str.replace(/(^| )(\w)/g, (s) => s.toUpperCase());
}
